// The admin-editable templates for the toasts the app pops on its own
// (TOAST_MESSAGE_REGISTRY on the backend). AppLayout loads them with its
// app-settings fetch; pages read synchronously through toastText. A
// localStorage copy covers the mount-time toasts that fire before the
// fetch lands (the first-ever visit falls back to the defaults once).
const KEY = "toastTemplates";
let templates = (() => {
  try { return JSON.parse(localStorage.getItem(KEY) || "{}") || {}; } catch { return {}; }
})();

export function setToastTemplates(map) {
  templates = map && typeof map === "object" ? map : {};
  try { localStorage.setItem(KEY, JSON.stringify(templates)); } catch {}
}

export function toastText(key, tokens = {}, fallback = "") {
  let out = String(templates[key] || fallback || "");
  Object.entries(tokens).forEach(([k, v]) => {
    out = out.split(`{${k}}`).join(String(v == null ? "" : v));
  });
  return out;
}
